import type { User } from '@takeshape/schema';
import gravatar from 'gravatar';
import { PureComponent } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Avatar = styled.div`
  border-radius: 50%;
  overflow: hidden;
  height: 2.4rem;
  width: 2.4rem;
  vertical-align: middle;
  margin-right: 1rem;
  flex-shrink: 0;
`;

type UserLabelProps = {
  readonly user: User;
};

export default class UserLabel extends PureComponent<UserLabelProps> {
  override render() {
    const { user } = this.props;
    const { fullName, email, avatarPath } = user;
    return (
      <Container>
        <Avatar>
          <img src={avatarPath ?? gravatar.url(email, { s: '24' }, true)} />
        </Avatar>
        {fullName}
      </Container>
    );
  }
}
